<template>
    <div class="row page">
        <div class="col-md-6 offset-md-3 p-5">
            <router-link :to="{ name: 'ResetPassword' }" tag="h1" class="mb-5">Wachtwoord Reset</router-link>

            <form @submit.prevent="send">
                <div class="form-group">
                    <label for="Password" hidden>Wachtwoord:</label>
                    <input 
                    placeholder="Wachtwoord..." 
                    name="Password" 
                    id="Password" 
                    type="password" 
                    required 
                    :class="['form-control', ($v.user.password.$dirty) ? ($v.user.password.$error) ?'is-invalid' : 'is-valid' : '']"
                    v-model="user.password" 
                    :disabled="isLoading">
                </div>
                <div class="form-group">
                    <label for="ConfirmPassword" hidden>Bevestig Wachtwoord:</label>
                    <input 
                    placeholder="Bevestig Wachtwoord..." 
                    ame="ConfirmPassword" 
                    id="ConfirmPassword" 
                    type="password" 
                    required 
                    :class="['form-control', ($v.user.confirmPassword.$dirty) ? ($v.user.confirmPassword.$error) ?'is-invalid' : 'is-valid' : '']"
                    v-model="user.confirmPassword" 
                    :disabled="isLoading">
                </div>
                <div class="form-group text-right">
                    <loader v-if="isLoading" width="2rem"></loader>
                    <button type="confirm" class="btn btn-half btn-outline-azure btn-lg mb-3" v-else :disabled="isLoading || isSuccess">
                        <span>Reset</span>
                        <div class="btn-icon">
                            <span>&rarr;</span>
                        </div>
                    </button>
                </div>
                <transition name="slide">
                    <div class="alert alert-warning" role="alert" v-if="(user.password != null && $v.user.password.$invalid) || (user.confirmPassword != null && $v.user.confirmPassword.$invalid)">
                        <ul class="mb-0">
                            <li v-if="user.password != user.confirmPassword && !!user.confirmPassword">Wachtwoorden moeten overeenkomen</li>
                            <li v-if="user.password.length < 6">Wachtwoord moet minimaal 6 karakters zijn</li>
                            <li v-if="!/[^a-zA-Z\d\s:]/.test(user.password)">Wachtwoord moet minimaal 1 speciaal karakter bevatten</li>
                            <li v-if="!/[a-z]/.test(user.password)">Wachtwoord moet minimaal kleine letter bevatten</li>
                            <li v-if="!/[A-Z]/.test(user.password)">Wachtwoord moet minimaal hoofdletter bevatten</li>
                            <li v-if="!/\d/.test(user.password)">Wachtwoord moet minimaal cijfer bevatten</li>
                        </ul>
                    </div>
                </transition>
                <div class="alert alert-danger" role="alert" v-if="isError">
                    <strong>Oeps!</strong> 
                    <ul>
                        <li v-for="err in errors" :key="err">{{err}}</li>
                    </ul>
                </div>
                <div class="alert alert-success" role="alert" v-if="isSuccess">
                    <strong>Succes!</strong> Het wachtwoord is gereset. U moet opnieuw <router-link tag="a" to="/account/login">inloggen</router-link>.
                </div>
            </form>
        </div>
    </div>
</template>

<script>
import Loader from '@/components/Loader';
import { validationMixin } from 'vuelidate';
import { required, minLength, email, sameAs, helpers } from 'vuelidate/lib/validators';

const hasUpper = helpers.regex('hasSpecialCharacter', /[A-Z]/);
const hasLower = helpers.regex('hasLower', /[a-z]/);
const hasNumber = helpers.regex('hasSpecialCharacter', /\d/);
const hasSpecialCharacter = helpers.regex('hasSpecialCharacter', /[^a-zA-Z\d\s:]/);    

export default {
    components: {
        'loader': Loader
    },
    mixins: [validationMixin],
    data() {
        return {
            user: {
                email: this.$route.query.username,
                password: '',
                confirmPassword: '',
                type: 'any'
            },
            isLoading: false,
            isSuccess: false,
            isError: false,
            errors: [],
        }
    },
    mounted() {
    },
    validations: {
        user: {
            email: {
                required,
                email
            },
            password: {
                required,
                hasUpper,
                hasLower,
                hasNumber,
                hasSpecialCharacter,
                minLength: minLength(6),
            },
            confirmPassword: {
                required,
                minLength: minLength(6),
                sameAs: sameAs('password'),
            }
        }
    },
    methods: {
        send() {
            this.isSuccess = false;
            this.isError = false;
            this.errors = [];
            
            if(this.user.password != this.user.confirmPassword && !!this.user.confirmPassword)
            {
                this.errors.push("Wachtwoorden komen niet overeen.");
                this.isError = true;
            }

            if(this.user.password.length < 6)
            {
                this.errors.push("Wachtwoord moet minimaal 6 tekens zijn.");
                this.isError = true;
            }
            
            if(!/[a-z]/.test(this.user.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 kleine letter bevatten.');
                this.isError = true;
            }

            if(!/[A-Z]/.test(this.user.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 hoofdletter letter bevatten.');
                this.isError = true;
            }

            if(!/\d/.test(this.user.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 cijfer bevatten.');
                this.isError = true;
            }

            if(!/[^a-zA-Z\d\s:]/.test(this.user.password))
            {
                this.errors.push('Wachtwoord moet minimaal 1 speciaal karakter bevatten.');
                this.isError = true;
            }

            if(this.isError)
            {
                return;
            }

            if(!this.isError)
            {
                this.isLoading = true;
                
                this.$http.post("api/Auth/ResetPassword?token=" + encodeURIComponent(this.$route.query.token), this.user).then(() => {
                    this.isSuccess = true;
                    this.isLoading = false;
                }).catch(() => {
                    this.errors.push("Wachtwoord reset is mislukt.");
                    this.isError = true;
                    this.isLoading = false;
                });
            }
        }
    }
}
</script>
